<template>
  <div class="jl-record-wrap">
    <div class="jl-record-content">
      <div class="record-header">
        <ul class="list clearfix">
          <li class="item-li">
            <div class="li-box">
              <img src="../../../assets/img/zkj-rec-icon1.png" alt />
              <span class="span-1">{{cardsNumber}}</span>
              <p class="text">举牌次数</p>
            </div>
          </li>
          <li class="item-li">
            <div class="li-box">
              <img src="../../../assets/img/zkj-rec-icon2.png" alt />
              <span class="span-1">{{participateNumber}}</span>
              <p class="text">参与次数</p>
            </div>
          </li>
          <li class="item-li">
            <div class="li-box">
              <img src="../../../assets/img/zkj-rec-icon3.png" alt />
              <span class="span-1">{{seckillNumber}}</span>
              <p class="text">秒杀次数</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="record-tabs">
        <div class="record-select" v-if="tabType === '2'">
          <div class="record-select-box">
            <p :class="[isShowSelect?'text active' : 'text']" @click.stop="showSelect">
              {{selectText}}
              <i class="jl-icon-sanjiao_down"></i>
            </p>
            <transition name="fade-down">
              <div class="record-select-down" v-show="isShowSelect">
                <ul class="list">
                  <li
                    v-for="(item, index) in selectOption"
                    :key="index"
                    @click.stop="selectClick(item)"
                    :class="[selectText === item.label?'selected':'']"
                  >{{item.label}}</li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
        <ul class="tabs-list clearfix">
          <li
            v-for="(item, index) in tabOption"
            :class="[tabType === item.value?'tab-li active':'tab-li']"
            :key="index"
            @click="changeTab(item)"
          >{{item.label}}</li>
        </ul>
      </div>

      <div class="record-content">
        <div class="jl-auc-view-list-wrap">
          <div v-loading="isloading" class="jl-loading-box">
            <div class="jl-com-nodata-tips" v-if="nodata">
              <div class="jl-com-nodata-box">
                <i class="jl-icon-wushuju"></i>
                <p class="text">暂无数据</p>
              </div>
            </div>
            <ul class="jl-auc-view-list clearfix">
              <li class="item" v-for="(item, index) in list" :key="index" @click="gotolink(item)">
                <div class="jl-view-listbox">
                  <div class="jl-view-lb-img">
                    <img :src="item.imgsUrl" />
                  </div>
                  <div class="jl-view-lb-info">
                    <div class="jl-tips" v-if="item.status == 1">已成交</div>
                    <h3>{{item.name}}</h3>
                    <p class="item-price">
                      起拍价：
                      <span>¥ {{item.startPrice}}</span>
                    </p>
                    <p class="text1">浏览人数：{{item.visitorsNumber}}人</p>
                    <p class="text1">时间：{{item.startDate}} ～ {{item.expectEndDate}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="jl-page-box clearfix" v-if="list.length > 0">
            <div style="float: right">
              <v-pagination
                :total="total"
                :display="display"
                :currentPage="current"
                @pagechange="pagechange"
              ></v-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAuctionRecordCount, getAuctionRecordList } from "../../../api/user";
import Pagination from "../../../components/Pagination";
export default {
  name: "accountAuctionRecord",
  components: {
    "v-pagination": Pagination
  },
  data() {
    return {
      list: [],
      userId: "",
      cardsNumber: "", //举牌次数
      participateNumber: "", //参与次数
      seckillNumber: "", //秒杀次数,
      isShowSelect: false,
      selectText: "已支付",
      selectOption: [
        {
          value: "2",
          label: "未支付"
        },
        {
          value: "1",
          label: "已支付"
        },
        {
          value: "0",
          label: "已逾期"
        }
      ],
      selectType: "1",
      tabOption: [
        {
          value: "0",
          label: "进行中"
        },
        {
          value: "1",
          label: "设置提醒"
        },
        {
          value: "2",
          label: "已拍得"
        },
        {
          value: "3",
          label: "未拍得"
        }
      ],
      tabType: "0",
      total: 1,
      display: 8,
      current: 1,
      isloading: true,
      nodata: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    const self = this;
    this.userId = this.userInfo.userId;
    this.getAuctionCount();
    this.getlist();
    document.body.onclick = function() {
      self.isShowSelect = false;
    };
  },
  methods: {
    //点击分页
    pagechange(idx) {
      this.current = idx;
      this.getlist();
      window.scrollTo(0, 0);
    },
    //改变tabs
    changeTab(item) {
      if (item.value === this.tabType) return;
      this.current = 1;
      this.tabType = item.value;
      this.getlist();
    },
    //显示下拉
    showSelect() {
      this.isShowSelect = !this.isShowSelect;
    },
    //选择下拉
    selectClick(item) {
      this.selectText = item.label;
      this.selectType = item.value;
      this.isShowSelect = false;
      this.getlist();
    },
    //获取相关拍卖次数
    getAuctionCount() {
      getAuctionRecordCount(this);
    },
    //根据不同状态查询列表
    getlist() {
      getAuctionRecordList(this);
    },
    gotolink(item) {
      /* item.detailType  // 0 => 普通详情, 1 => 含有订单信息详情 */
      if (this.tabType === "2") {
        /* this.$router.push({
          name: "accountAuctionDetail",
          params: {
            id: item.id
          }
        }); */
        this.$router.push({
          path: "/account/order/detail/" + item.id
        });
      } else {
        this.$router.push({
          path: "/auction/detail/index",
          query: {
            id: item.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-down-enter-active,
.fade-down-leave-active {
  transition: all 0.3s ease;
}
.fade-down-enter, 
.fade-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
.jl-record-content {
  .record-header {
    background: url("../../../assets/img/zkj-acc-aucbg.jpg") no-repeat center
      center;
    background-size: cover;
  }
  .item-li {
    position: relative;
    float: left;
    width: 33.33%;
    padding: 28px 0;
    text-align: center;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 1px;
      height: 52px;
      background: #444;
      margin-top: -26px;
    }
    .li-box {
      display: inline-block;
      img,
      span {
        display: inline-block;
        vertical-align: middle;
      }
      .span-1 {
        font-size: 32px;
        color: #fff;
        margin-left: 6px;
      }
      .text {
        font-size: 14px;
        color: #fff;
        margin-top: 15px;
      }
    }
  }
  .record-tabs {
    position: relative;
    background: #fff;
    z-index: 10;
    .tab-li {
      position: relative;
      float: left;
      width: 122px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      &::before {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        display: block;
        width: 1px;
        height: 10px;
        background: #e0e0e0;
        margin-top: -5px;
      }
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        display: block;
        width: 100%;
        height: 0;
        background: #e81727;
      }
      &.active::after {
        height: 1px;
      }
    }
    .record-select-box {
      position: relative;
    }
    .record-select {
      position: absolute;
      right: 15px;
      top: 50%;
      width: 92px;
      height: 36px;
      margin-top: -18px;
      .text {
        position: relative;
        padding-left: 15px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        color: #333;
        border: 1px solid #333;
        cursor: pointer;
        i {
          display: inline-block;
          transition: all 0.3s;
        }
        &.active {
          i {
            transform: rotate(180deg);
          }
        }
      }
    }
    .record-select-down {
      position: absolute;
      left: 0;
      top: 100%;
      padding-top: 12px;
      width: 100%;
      .list {
        position: relative;
        background: #fff;
        box-shadow: 0 0 15px rgba(184, 184, 184, 0.5);
        z-index: 100;
        &::before {
          content: "";
          position: absolute;
          top: -5px;
          right: 10px;
          width: 10px;
          height: 10px;
          background: #fff;
          transform: rotate(45deg);
          z-index: -1;
        }
        li {
          height: 44px;
          line-height: 44px;
          text-align: center;
          font-size: 14px;
          color: #333;
          border-bottom: 1px solid #e0e0e0;
          cursor: pointer;
          &:last-child {
            border-bottom: none;
          }
          &.selected {
            background: #e50011;
            color: #fff;
          }
        }
      }
    }
  }
  .record-content {
    background: #f8f8fb;
    padding-top: 20px;
    padding-bottom: 22px;
    .jl-auc-view-list {
      margin-left: -10px;
      margin-right: -10px;
      .item {
        float: left;
        width: 25%;
        padding: 0 10px 20px 10px;
        cursor: pointer;
      }
      .jl-view-listbox {
        box-shadow: 5px 5px 10px rgba(184, 184, 184, 0.5);
      }
      .jl-view-lb-img {
        position: relative;
        // height: 317px;
        overflow: hidden;
        background: #fff;
        text-align: center;
        &::after {
          /* content: "";
          display: inline-block;
          vertical-align: middle;
          width: 0;
          height: 100%; */
        }
        img {
          /* display: inline-block;
          vertical-align: middle;
          max-width: 100%;
          max-height: 100%; */
          display: block;
          width: 100%;
          transition: all 0.3s;
        }
      }
      .jl-view-lb-info {
        position: relative;
        background: #fff;
        padding: 10px 10px 5px 10px;
        .jl-tips {
          position: absolute;
          right: 0;
          top: 20px;
          display: block;
          width: 56px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #999;
          background: #ccc;
          border-top-left-radius: 12px;
          border-bottom-left-radius: 12px;
        }
        h3 {
          font-size: 16px;
          color: #333;
          margin-bottom: 20px;
        }
        .item-price {
          font-size: 14px;
          columns: #666;
          padding-bottom: 15px;
          border-bottom: 1px solid #e0e0e0;
          margin-bottom: 15px;
          span {
            font-size: 18px;
            color: #e50011;
          }
        }
        .text1 {
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .jl-record-content .record-tabs .tab-li:hover::after {
    height: 1px;
  }
  .jl-auc-view-list .item:hover .jl-view-lb-img img {
    transform: scale(1.1);
  }
  .jl-auc-view-list .item:hover .jl-view-listbox {
    box-shadow: 5px 5px 10px rgba(184, 184, 184, 0.85);
  }
  .jl-record-content .record-tabs .record-select-down .list li:hover {
    background: #e50011;
    color: #fff;
  }
}
</style>


